import React from "react";
import { TallyConnectorDownload } from "../components/TallyConnectorDownload";

export const TallyConnectorPage: React.FC = () => {
  return (
    <div className="flex w-full flex-col gap-4 px-8 py-8">
      <div className="flex flex-col gap-1">
        <h1 className="text-heading-1 font-heading-1 text-default-font">Tally connector</h1>
        <p className="max-w-xl text-body font-body text-subtext-color">
          Install this on the Windows computer where TallyPrime is open. After it downloads, open it and sign in with this Zournal address, your email, and your password. Leave the matching company loaded in Tally.
        </p>
      </div>
      <TallyConnectorDownload />
    </div>
  );
};
